<template>
  <div>Loading...</div>
</template>

<script>
import oauth2 from "../../config/oauth2";
import qs from "qs";

export default {
  name: "OAuthCallbackLogin",
  created() {
    const that = this;
    let redirectPath = that.$route.query.redirectPath;
    let data = {};
    data.accessToken = that.$route.query.accessToken;
    let params = {};
    if (that.$route.query.qs) {
      if (that.$route.query.qs.length != 0) {
        var items = that.$route.query.qs.split("&");
        for (var i = 0; i < items.length; i++) {
          var item = items[i].split("=");
          let key = item[0];
          let value = item[1];
          if (key.length) {
            params[key] = value;
          }
        }
      }
    }
    this.$http
      .post("/api/1/oauth/dggd/client", qs.stringify(data))
      .then(function(data) {
        if (data.code !== 200) {
          window.location.href = oauth2.getLoginUrl();
          return;
        }
        that.$store.dispatch("SetToken", data.user.token).then(function() {
          // eslint-disable-next-line no-undef
          that.$router.push({
            path: redirectPath,
            query: params
          });
          // window.location.href = WEB_SERVER + '/#/dashboard/workplace?_=' + new Date().getTime();
        });
      });
  }
};
</script>

<style scoped>
</style>
